import React, { createContext, useContext } from 'react'
import { GetBrandBySlugQuery } from 'types/graphql'
import { MaxWidthContainer } from 'lib/Section'
import { Page } from 'modules/Page'
import { useBrand } from 'modules/brands/queries/useBrand'
import { NotFound } from '../NotFound'

interface Context {
  brand: NonNullable<GetBrandBySlugQuery['brand']>
}

export const BrandContext = createContext<Context>({
  brand: null
})

interface Props {
  slug: string
  children: React.ReactNode
}
export const CurrentBrandProvider = ({ slug, children }: Props) => {
  const { data, loading } = useBrand(slug)

  if (!data?.brand || loading) {
    return (
      <Page>
        <MaxWidthContainer>
          <NotFound />
        </MaxWidthContainer>
      </Page>
    )
  }

  return <BrandContext.Provider value={{ brand: data.brand }}>{children}</BrandContext.Provider>
}

export const useCurrentBrand = () => {
  return useContext(BrandContext)
}
